import { Stack, Text, Link } from '@ltvco/refresh-lib/theme';
import { InfoOutlined } from '@mui/icons-material';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

interface FreePlanDisclaimerProps {
  entityType: 'repair_estimate' | 'vehicle_matchmaker' | 'value_forecaster';
}

export const FreePlanDisclaimer = ({ entityType }: FreePlanDisclaimerProps) => {
  const navigate = useNavigate();
  const entityTypeText = useMemo(() => {
    switch (entityType) {
      case 'repair_estimate':
        return 'repair estimate';
      case 'vehicle_matchmaker':
        return 'vehicle matches';
      case 'value_forecaster':
        return 'value forecast';
      default:
        return 'feature';
    }
  }, [entityType]);

  const handleUpgradeClick = () => {
    navigate('/subscribe');
  };

  return (
    <Stack alignItems="flex-start" direction="row" mb={2}>
      <InfoOutlined fontSize="small" sx={{ color: 'text.secondary', mr: 1 }} />
      <Text variant="caption" color="text.secondary">
        This {entityTypeText} uses the limited data available on a free account.
        Key value-impacting factors—such as accidents, ownership history,
        recalls, thefts, and title issues—are not included.{' '}
        <Link
          onClick={handleUpgradeClick}
          sx={{ cursor: 'pointer', textDecoration: 'underline' }}
        >
          Upgrade
        </Link>{' '}
        to unlock these details and generate a more accurate {entityTypeText}.
      </Text>
    </Stack>
  );
};
